const VERCEL_CONFIG = { apiUrl: "https://project-ircvc.vercel.app/api/create-product" };

const CONFIG = {
    margin: 10,
    gap: 5, //inç
    psSurcharge: 0.7, // Peel & Stick metre başı ekstra ücret
    doubleFrameOffsetCm: 12.7 
};

// --- ÇITA MODELLERİ (GERÇEK VERİLER VE GALERİLER) ---
const profiles = [
    { 
        id: "prof1", name: "2513 (W=0.98in - H=0.51in)", price: 6.00, 
        img: "https://cdn.shopify.com/s/files/1/0657/3237/8844/files/2513_5e8e7038-326d-4d1a-802a-e44a4484db7f.jpg",
        gallery: [] 
    },
    { 
        id: "prof2", name: "4020 (W=1.57in - H=0.79in)", price: 7.00, 
        img: "https://cdn.shopify.com/s/files/1/0657/3237/8844/files/4020_be34ed2c-dc32-4327-9a89-c3b28da16467.jpg",
        gallery: [] 
    },
    { 
        id: "prof3", name: "4017 (W=1.57in - H=0.67in)", price: 7.00, 
        img: "https://cdn.shopify.com/s/files/1/0657/3237/8844/files/4017_8c232da0-75a3-47f9-b161-4b4e52d2c62f.jpg",
        gallery: [] 
    },
    { 
        id: "prof4", name: "4010 (W=1.57in - H=0.39in)", price: 7.00, 
        img: "https://cdn.shopify.com/s/files/1/0657/3237/8844/files/4010_d3d2434b-5d6f-4293-99bb-8b1672ce1f91.jpg",
        gallery: [] 
    }
];

const models = [
    {
        id: "paket1", name: "Layout 1 ", image: "https://birdeco.com/cdn/shop/files/1_710df8d6-ecc0-45a0-a8ac-348f235f6e29.png",
        unitSystem: { totalUnitsX: 12.5, totalUnitsY: 18 },
        shapes: [
            { id: "s1", x: 0, y: 0, w: 6, h: 12 }, { id: "s2", x: 0, y: 13, w: 6, h: 5 },
            { id: "s3", x: 6.5, y: 0, w: 6, h: 12 }, { id: "s4", x: 6.5, y: 13, w: 6, h: 5 }
        ]
    },

    {
        id: "paket3", name: "Layout 2", image: "https://birdeco.com/cdn/shop/products/Ready-to-Assemble-Wall-Molding-Kit-to-Make-3-Upper-and-3-Middle-and-3-Bottom-Frames-P3-Highest-Quality-Wall-Moldings-and-Decor-Products-at-Birdeco-9594.webp",
        unitSystem: { totalUnitsX: 19, totalUnitsY: 22 },
        shapes: [
            { id: "s1", x: 0, y: 0, w: 6, h: 4.5 }, { id: "s2", x: 0, y: 5, w: 6, h: 12 },{ id: "s3", x: 0, y: 17.5, w: 6, h: 4.5 },
            { id: "s4", x: 6.5, y: 0, w: 6, h: 4.5},{ id:"s5", x: 6.5, y: 5, w: 6, h: 12 },{ id: "s6", x: 6.5, y: 17.5, w: 6, h: 4.5 },
            { id: "s7", x: 13, y: 0, w: 6, h: 4.5 }, { id: "s8", x: 13, y: 5, w: 6, h: 12 },{ id: "s9", x:13, y: 17.5, w: 6, h: 4.5 },
        ]
    },

    {
        id: "paket8", name: "Layout 3", image: "https://birdeco.com/cdn/shop/products/Wall-Molding-Kit-Ready-to-install-4-Upper-4-Middle-and-4-BottoM-Frames-P8-Highest-Quality-Wall-Moldings-and-Decor-Products-at-Birdeco-5938.webp",
        unitSystem: { totalUnitsX: 43, totalUnitsY: 23.6 },
        shapes: [
            { id: "s1", x: 0, y: 0, w: 10, h: 14 }, { id: "s2", x: 0, y: 14.5, w: 10, h: 2.5 },{ id: "s3", x: 0, y: 17.5, w: 10, h: 6.1 },
            { id: "s4", x: 11, y: 0, w: 10, h: 14 }, { id: "s5", x: 11, y: 14.5, w: 10, h: 2.5 },{ id: "s6", x: 11, y: 17.5, w: 10, h: 6.1 },
            { id: "s7", x: 22, y: 0, w: 10, h: 14 }, { id: "s8", x: 22, y: 14.5, w: 10, h: 2.5 },{ id: "s9", x: 22, y: 17.5, w: 10, h: 6.1 },
            { id: "s10", x: 33, y: 0, w: 10, h: 14 }, { id: "s11", x: 33, y: 14.5, w: 10, h: 2.5 },{ id: "s12", x: 33, y: 17.5, w: 10, h: 6.1 }

        ]
    },

    {
        id: "paket32", name: "Layout 4", image: "https://birdeco.com/cdn/shop/files/10000copy.webp",
        unitSystem: { totalUnitsX: 32, totalUnitsY: 24 },
        shapes: [
            { id: "s1", x: 0, y: 0, w: 10, h: 16 }, { id: "s2", x: 0, y: 17, w: 10, h: 7 },
            { id: "s3", x: 11, y: 0, w: 10, h: 16 }, { id: "s4", x: 11, y: 17, w: 10, h: 7 },
            { id: "s5", x: 22, y: 0, w: 10, h: 16 }, { id: "s6", x: 22, y: 17, w: 10, h: 7 }
        ]
    },
    {
        id: "paket25", name: "Layout 5", image: "https://birdeco.com/cdn/shop/files/25.png",
        unitSystem: { totalUnitsX: 36, totalUnitsY: 23 },
        shapes: [
            { id: "s1", x: 0, y: 0, w: 8, h: 16 }, { id: "s2", x: 0, y: 17, w: 8, h: 6 },
            { id: "s3", x: 9, y: 0, w: 18, h: 16 }, { id: "s4", x: 9, y: 17, w: 18, h: 6 },
            { id: "s5", x: 28, y: 0, w: 8, h: 16 }, { id: "s6", x: 28, y: 17, w: 8, h: 6 }
        ]
    },
    {
        id: "paket30", name: "Layout 6", image: "https://cdn.shopify.com/s/files/1/0657/3237/8844/files/1_96e78b70-66a3-49c5-a7ec-a133026e502c.jpg",
        unitSystem: { totalUnitsX: 14, totalUnitsY: 8 },
        shapes: [
            { id: "s1", x: 0, y: 0, w: 2, h: 8 }, { id: "s2", x: 2.5, y: 0, w: 3, h:8 },
            { id: "s3", x: 6, y: 0, w: 2, h: 8 }, { id: "s4", x: 8.5, y: 0, w: 3, h: 8 },
            { id: "s5", x: 12, y: 0, w: 2, h: 8 }
        ]
    },
    {
        id: "paket43", name: "Layout 7", image: "https://cdn.shopify.com/s/files/1/0657/3237/8844/files/c3cb5b88263571.5dd18039703cf.jpg",
        unitSystem: { totalUnitsX: 36, totalUnitsY: 24 },
        shapes: [
            { id: "s1", x: 0, y: 0, w: 7, h: 24 }, 
            { id: "s2", x: 8, y: 0, w: 20, h:11 },
            { id: "s3", x: 29, y: 0, w: 7, h:24 }
        ]
    },
    {
        id: "paket26", name: "Layout 8", image: "https://birdeco.com/cdn/shop/products/Ready-to-Assemble-Wall-Molding-Kit-Accent-Wall-Design-P29-Highest-Quality-Wall-Moldings-and-Decor-Products-at-Birdeco-6956.webp",
        unitSystem: { totalUnitsX: 29, totalUnitsY: 25 },
        shapes: [
            { id: "s1", x: 0, y: 0, w: 9, h: 25 }, 
            { id: "s2", x: 10, y: 0, w: 9, h:25 },
            { id: "s3", x: 20, y: 0, w: 9, h:25 }
        ]
    }
];

let selectedModelId = null;
let selectedOuterProfileId = profiles[0].id;
let selectedInnerProfileId = profiles[0].id;

document.addEventListener('DOMContentLoaded', () => {
    // 1. Tasarım Şablonlarını Yükle
    const layoutList = document.getElementById('layout-list');
    if (layoutList) {
        models.forEach(m => {
            layoutList.innerHTML += `
                <div class="col"><div class="card h-100 shadow-sm model-card" id="layout-${m.id}" onclick="selectLayout('${m.id}')">
                    <img src="${m.image}" class="card-img-top p-2" alt="${m.name}">
                    <div class="card-body text-center"><h6 class="card-title fw-bold mb-0">${m.name}</h6></div>
                </div></div>`;
        });
    }

    // 2. Çıta Profillerini Yükle (Galeri ile Birlikte)
    const outerList = document.getElementById('outer-profile-list');
    const innerList = document.getElementById('inner-profile-list');

    if (outerList && innerList) {
        profiles.forEach(p => {
            // Küçük galeri görsellerini oluştur
            // Küçük galeri görsellerini oluştur
            let galleryHTML = `<div class="profile-gallery">` + 
                p.gallery.map(imgSrc => `<img src="${imgSrc}" alt="Örnek Uygulama" onclick="openImageModal(event, '${imgSrc}')">`).join('') + 
                `</div>`;

            let cardHTML = `
                <div class="col"><div class="card h-100 shadow-sm profile-card" id="[PREFIX]-${p.id}" onclick="selectProfile('[TYPE]', '${p.id}')">
                    <img src="${p.img}" class="card-img-top p-2" alt="${p.name}">
                    <div class="card-body text-center border-top">
                        <h6 class="fw-bold mb-1" style="font-size:15px;">${p.name}</h6>
                        <span class="text-success fw-bold">$${p.price.toFixed(2)}/m</span>
                        ${galleryHTML}
                    </div>
                </div></div>`;
            
            outerList.innerHTML += cardHTML.replace('[PREFIX]', 'outer').replace('[TYPE]', 'outer');
            innerList.innerHTML += cardHTML.replace('[PREFIX]', 'inner').replace('[TYPE]', 'inner');
        });
        
        selectProfile('outer', selectedOuterProfileId);
        selectProfile('inner', selectedInnerProfileId);
    }

    // 3. Görsel Dropdownları Hazırla
    buildCustomDropdowns();
});

// --- GÖRSEL DROPDOWN (AÇILIR MENÜ) MANTIĞI ---
function buildCustomDropdowns() {
    buildSingleDropdown('layout', models, selectedModelId, (id) => {
        selectLayout(id); calculateAndDraw();
    });
    buildSingleDropdown('outer', profiles, selectedOuterProfileId, (id) => {
        selectProfile('outer', id); calculateAndDraw();
    });
    buildSingleDropdown('inner', profiles, selectedInnerProfileId, (id) => {
        selectProfile('inner', id); calculateAndDraw();
    });
}

function buildSingleDropdown(type, dataArray, selectedId, onChangeCallback) {
    const container = document.getElementById(`dropdown-${type}-container`);
    if(!container) return;
    
    let listHTML = dataArray.map(item => `
        <div class="custom-dropdown-item" onclick="handleDropdownSelect('${type}', '${item.id}')">
            <img src="${item.img || item.image}" class="custom-dropdown-img">
            <div>
                <div style="font-size:14px; font-weight:600; color:#333;">${item.name}</div>
                ${item.price ? `<div style="font-size:13px; color:#198754;">$${item.price.toFixed(2)}/m</div>` : ''}
            </div>
        </div>
    `).join('');

    const selectedItem = dataArray.find(x => x.id === selectedId) || dataArray[0];

    container.innerHTML = `
        <div class="custom-dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" id="toggle-${type}">
            <div style="display:flex; align-items:center;">
                <img src="${selectedItem.img || selectedItem.image}" class="custom-dropdown-img" style="width:30px; height:30px; margin-right:8px;">
                <span>${selectedItem.name}</span>
            </div>
            <span>▼</span>
        </div>
        <div class="dropdown-menu custom-dropdown-menu shadow-sm">${listHTML}</div>
    `;

    window[`handleDropdownSelect_${type}`] = onChangeCallback;
}

function handleDropdownSelect(type, id) {
    window[`handleDropdownSelect_${type}`](id);
    
    let dataArray = type === 'layout' ? models : profiles;
    let selectedItem = dataArray.find(x => x.id === id);
    let toggle = document.getElementById(`toggle-${type}`);
    if(toggle) {
        toggle.innerHTML = `
            <div style="display:flex; align-items:center;">
                <img src="${selectedItem.img || selectedItem.image}" class="custom-dropdown-img" style="width:30px; height:30px; margin-right:8px;">
                <span>${selectedItem.name}</span>
            </div>
            <span>▼</span>
        `;
    }
}

// --- SEÇİM VE SENKRONİZASYON ---
function selectLayout(id) {
    selectedModelId = id;
    document.querySelectorAll('#layout-list .model-card').forEach(c => c.classList.remove('selected'));
    if(document.getElementById(`layout-${id}`)) document.getElementById(`layout-${id}`).classList.add('selected');
}

function selectProfile(type, id) {
    if(type === 'outer') {
        selectedOuterProfileId = id;
        document.querySelectorAll('#outer-profile-list .profile-card').forEach(c => c.classList.remove('selected'));
        if(document.getElementById(`outer-${id}`)) document.getElementById(`outer-${id}`).classList.add('selected');
    } else {
        selectedInnerProfileId = id;
        document.querySelectorAll('#inner-profile-list .profile-card').forEach(c => c.classList.remove('selected'));
        if(document.getElementById(`inner-${id}`)) document.getElementById(`inner-${id}`).classList.add('selected');
    }
}

function syncDoubleFrame(isChecked) {
    document.getElementById('check-double-frame').checked = isChecked;
    toggleInnerProfileSelection();
}

function toggleInnerProfileSelection() {
    const isDouble = document.getElementById('check-double-frame').checked;
    
    const previewCheckbox = document.getElementById('check-double-frame-preview');
    if (previewCheckbox) previewCheckbox.checked = isDouble;

    document.getElementById('inner-profile-section').style.display = isDouble ? 'block' : 'none';
    document.getElementById('preview-inner-group').style.display = isDouble ? 'block' : 'none';
    
    if (document.getElementById('step-4').style.display === 'block') {
        calculateAndDraw();
    }
}

function syncDimensions(type) {
    const mainW = document.getElementById('wall-width');
    const mainH = document.getElementById('wall-height');
    const preW = document.getElementById('preview-width');
    const preH = document.getElementById('preview-height');
    if (type === 'w') mainW.value = preW.value; else mainH.value = preH.value;
    calculateAndDraw();
}

// --- ADIM KONTROLÜ VE YUKARI KAYDIRMA ---
function scrollToTop() {
    const wrapper = document.querySelector('.molding-app-wrapper');
    if(wrapper) {
        // Yumuşak bir şekilde uygulamanın en üstüne kaydır (mobilde çok işe yarar)
        wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}

function nextStep(step) {
    const wallW = document.getElementById('wall-width').value;
    const wallH = document.getElementById('wall-height').value;

    if (step === 2 && (!wallW || !wallH)) return alert("Please enter the wall dimensions...");
    if (step === 3 && !selectedModelId) return alert("Please select a design.");
    if (step === 4 && !selectedOuterProfileId) return alert("Please select a molding style.");

    document.querySelectorAll('.step-section').forEach(s => s.style.display = 'none');
    document.getElementById(`step-${step}`).style.display = 'block';

    document.querySelectorAll('.step-indicator').forEach(ind => ind.classList.remove('active'));
    document.getElementById(`ind-${step}`).classList.add('active');

    if (step === 4) {
        buildCustomDropdowns(); // Dropdownları son seçilenlere göre güncelle
        calculateAndDraw();
    }
    
    // Adım değiştiğinde yukarı kaydır
    scrollToTop();
}

function prevStep(step) {
    document.querySelectorAll('.step-section').forEach(s => s.style.display = 'none');
    document.getElementById(`step-${step}`).style.display = 'block';
    
    document.querySelectorAll('.step-indicator').forEach(ind => ind.classList.remove('active'));
    document.getElementById(`ind-${step}`).classList.add('active');
    
    // Adım değiştiğinde yukarı kaydır
    scrollToTop();
}

// --- ANA ÇİZİM VE FİYAT HESAPLAMA MOTORU ---
function calculateAndDraw() {
    const wallW = parseFloat(document.getElementById('wall-width').value);
    const wallH = parseFloat(document.getElementById('wall-height').value);
    document.getElementById('preview-width').value = wallW;
    document.getElementById('preview-height').value = wallH;
    
    const unit = document.getElementById('unit-select').value;
    const isDouble = document.getElementById('check-double-frame').checked;
    const isPS = document.getElementById('check-peel-stick').checked;
    document.getElementById('unit-badge').innerText = `Birim: ${unit.toUpperCase()}`;

    const wCm = unit === 'inch' ? wallW * 2.54 : wallW;
    const hCm = unit === 'inch' ? wallH * 2.54 : wallH;

    const model = models.find(m => m.id === selectedModelId);
    if (!model) return;
    
    const netW = wCm - (2 * CONFIG.margin); 
    const netH = hCm - (2 * CONFIG.margin);
    const unitX = netW / model.unitSystem.totalUnitsX;
    const unitY = netH / model.unitSystem.totalUnitsY;

    let outerMeters = 0;
    let innerMeters = 0;
    const unitLabel = unit === 'inch' ? 'in' : 'cm';
    const fontSize = 9;

    let svgContent = `<svg width="100%" height="100%" viewBox="0 0 ${wCm} ${hCm}" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" style="background: white; border: 1px solid #ddd;">
        <rect width="${wCm}" height="${hCm}" fill="#ffffff" />`;

    model.shapes.forEach(shape => {
        const x = CONFIG.margin + (shape.x * unitX);
        const y = CONFIG.margin + (shape.y * unitY);
        const w = shape.w * unitX;
        const h = shape.h * unitY;

        const displayW = unit === 'inch' ? Math.round(w / 2.54) : Math.round(w);
        const displayH = unit === 'inch' ? Math.round(h / 2.54) : Math.round(h);

        // Dış Çerçeve Çizimi
        svgContent += `<rect x="${x}" y="${y}" width="${w}" height="${h}" fill="none" stroke="#2c3e50" stroke-width="2"/>`;
        svgContent += `<text x="${x + w/2}" y="${y + 11}" font-size="${fontSize}" text-anchor="middle" fill="#e67e22" font-weight="bold">${displayW}${unitLabel}</text>`;
        svgContent += `<text x="${x + 11}" y="${y + h/2}" font-size="${fontSize}" text-anchor="middle" fill="#e67e22" font-weight="bold" transform="rotate(-90, ${x + 11}, ${y + h/2})">${displayH}${unitLabel}</text>`;

        outerMeters += unit === 'inch' ? ((2 * (displayW + displayH)) * 0.0254) : ((2 * (displayW + displayH)) / 100);

        // İç Çerçeve Çizimi (Double Frame)
        if (isDouble) {
            const offsetCm = CONFIG.doubleFrameOffsetCm;
            if (w > (offsetCm * 2) && h > (offsetCm * 2)) {
                const ix = x + offsetCm;
                const iy = y + offsetCm;
                const iw = w - (offsetCm * 2);
                const ih = h - (offsetCm * 2);

                const displayIW = unit === 'inch' ? Math.round(iw / 2.54) : Math.round(iw);
                const displayIH = unit === 'inch' ? Math.round(ih / 2.54) : Math.round(ih);

                svgContent += `<rect x="${ix}" y="${iy}" width="${iw}" height="${ih}" fill="none" stroke="#bdc3c7" stroke-width="2" />`;
                svgContent += `<text x="${ix + iw/2}" y="${iy + 15}" font-size="${fontSize-1}" text-anchor="middle" fill="#95a5a6">${displayIW}x${displayIH}</text>`;
                
                innerMeters += unit === 'inch' ? ((2 * (displayIW + displayIH)) * 0.0254) : ((2 * (displayIW + displayIH)) / 100);
            }
        }
    });

    svgContent += `</svg>`;
    document.getElementById('svg-container').innerHTML = svgContent;

    // --- DETAYLI FİYAT HESAPLAMASI ---
    const outerProfile = profiles.find(p => p.id === selectedOuterProfileId);
    const outerTotalPrice = outerMeters * outerProfile.price;
    
    document.getElementById('outer-meters-display').innerText = outerMeters.toFixed(2);
    document.getElementById('outer-price-display').innerText = outerTotalPrice.toFixed(2);

    let finalPrice = outerTotalPrice;

    if (isDouble) {
        const innerProfile = profiles.find(p => p.id === selectedInnerProfileId);
        const innerTotalPrice = innerMeters * innerProfile.price;
        document.getElementById('inner-price-row').style.display = 'flex';
        document.getElementById('inner-meters-display').innerText = innerMeters.toFixed(2);
        document.getElementById('inner-price-display').innerText = innerTotalPrice.toFixed(2);
        finalPrice += innerTotalPrice;
    } else {
        document.getElementById('inner-price-row').style.display = 'none';
    }

    if (isPS) {
        const totalMeters = outerMeters + innerMeters;
        const psTotalPrice = totalMeters * CONFIG.psSurcharge;
        document.getElementById('ps-price-row').style.display = 'flex';
        document.getElementById('ps-price-display').innerText = psTotalPrice.toFixed(2);
        finalPrice += psTotalPrice;
    } else {
        document.getElementById('ps-price-row').style.display = 'none';
    }

    document.getElementById('final-price').innerText = finalPrice.toFixed(2);
    
    document.getElementById('add-to-cart').dataset.totalMeters = (outerMeters + innerMeters).toFixed(2);
}

// --- SEPETE EKLEME API İSTEĞİ ---
const addToCartBtn = document.getElementById('add-to-cart');
if (addToCartBtn) {
    addToCartBtn.addEventListener('click', async function(e) {
        e.preventDefault();
        
        // 1. Loading Modalını Ekrana Getir
        const loadingModalEl = document.getElementById('loadingModal');
        let loadingModal = null;
        if (loadingModalEl) {
            loadingModal = new bootstrap.Modal(loadingModalEl);
            loadingModal.show();
        }
        
        const originalText = this.innerText;
        this.innerText = "İşleniyor...";
        this.disabled = true;

        try {
            const width = document.getElementById('wall-width').value;
            const height = document.getElementById('wall-height').value;
            const unit = document.getElementById('unit-select').value;
            const finalPrice = document.getElementById('final-price').innerText;
            const isPeelAndStick = document.getElementById('check-peel-stick').checked;
            const totalMeters = this.dataset.totalMeters;

            const model = models.find(m => m.id === selectedModelId);
            const outerProf = profiles.find(p => p.id === selectedOuterProfileId);
            const isDouble = document.getElementById('check-double-frame').checked;
            
            // Profil numaralarını ayıklama (Örn: "4017 (W=..." stringinden "4017" değerini alır)
            const outerCode = outerProf.name.split(' ')[0];
            let innerCode = "";
            
            if(isDouble) {
                const innerProf = profiles.find(p => p.id === selectedInnerProfileId);
                innerCode = innerProf.name.split(' ')[0];
            }

            // 1. SEO Uyumlu Başlık
            const prefix = isPeelAndStick ? "Peel and Stick " : "";
            const titleString = `${prefix}Custom Wall Molding Kit - ${model.name} Design | Birdeco`;

            // 2. Dinamik SKU Oluşturma
            const baseSku = model ? model.id : "00";
            let finalSku = `${baseSku}-${outerCode}`;
            if (isDouble) finalSku += `-${innerCode}`;
            if (isPeelAndStick) finalSku += `-P`;

            const svgNode = document.querySelector('#svg-container svg');
            const svgData = new XMLSerializer().serializeToString(svgNode);
            const svgBlob = new Blob([svgData], {type: 'image/svg+xml;charset=utf-8'});
            const DOMURL = window.URL || window.webkitURL || window;
            const url = DOMURL.createObjectURL(svgBlob);

            const img = new Image();
            img.onload = async function() {
                const viewBox = svgNode.getAttribute('viewBox').split(' ');
                const canvas = document.createElement('canvas');
                canvas.width = parseInt(viewBox[2]) * 3; 
                canvas.height = parseInt(viewBox[3]) * 3;
                
                const ctx = canvas.getContext('2d');
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                DOMURL.revokeObjectURL(url);

                const base64Image = canvas.toDataURL('image/png').split(',')[1];

                const payload = {
                    title: titleString,
                    sku: finalSku,
                    price: finalPrice,
                    totalMeters: totalMeters,
                    dimensions: { w: width, h: height, unit: unit },
                    peelAndStick: isPeelAndStick,
                    imageBase64: base64Image
                };

                const response = await fetch(VERCEL_CONFIG.apiUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                });

                const result = await response.json();

                if (result.success && result.variantId) {
                    // Yönlendirme başarılı olursa modalın kapatılmasına gerek yoktur, sayfa değişecektir.
                    window.location.href = `https://birdeco.myshopify.com/cart/${result.variantId}:1`;
                } else {
                    throw new Error(result.error || "Vercel API Hatası");
                }
            };
            
            img.src = url;

        } catch (error) {
            console.error("İşlem Hatası:", error);
            alert("İşlem başarısız oldu: " + error.message);
            
            // Hata durumunda sistemi başlangıç durumuna döndür
            this.innerText = originalText;
            this.disabled = false;
            if (loadingModal) {
                loadingModal.hide();
            }
        }
    });
}

// Galeri Görselini Büyütme Fonksiyonu
function openImageModal(event, src) {
    event.stopPropagation(); // Kart seçimini engelle
    const modalEl = document.getElementById('imageModal');
    if(modalEl) {
        document.getElementById('enlarged-image').src = src;
        const modal = new bootstrap.Modal(modalEl);
        modal.show();
    }
}